import {takeEvery} from 'redux-saga/effects'
import {
  CREATE_CLIENT_SECRETS,
  DELETE_CLIENT_SECRETS,
  GET_CLIENT_SECRETS,
  GET_EXTERNAL_API_DOCUMENTATION,
  SHOW_CLIENT_SECRETS,
  UPDATE_CLIENT_SECRETS,
} from 'setup/redux/Actions/ClientSecrets/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_CLIENT_SECRETS, fetchData)
  yield takeEvery(DELETE_CLIENT_SECRETS, fetchData)
  yield takeEvery(CREATE_CLIENT_SECRETS, fetchData)
  yield takeEvery(SHOW_CLIENT_SECRETS, fetchData)
  yield takeEvery(UPDATE_CLIENT_SECRETS, fetchData)
  yield takeEvery(GET_EXTERNAL_API_DOCUMENTATION, fetchData)
}

export default dataSaga
